import { FORMINPUT, FORMINPUTNUMBER, FORMSELECT, FORMDATEPICKER, FORMTIMEPICKER, FORMSLECTDEPT, FORMSLECTUSER } from './libs/constants'
import { reactive } from 'vue'
import { getOptionsByKey } from './libs/getOptions'
import { vaildNull } from './libs/utils'
import { isRef } from 'vue'
export * from './libs/constants'
export { registerOptions, getOptionsByKey } from './libs/getOptions'
const EventList = ['events', 'hooks']
/*
  传入对象数组
  {
    key:'',表单的key,可以为数组
    type:'',//表单类型，枚举值
    options:[{label:'',value:''}]//select的options选项，可不填 ，由前端定义的options枚举值可放到./libs/getOptions中获取
    props:{ //绑定到表单组件的属性，与ant文档一致

    },
    events:{ //绑定到表单的事件，与ant文档一致

    },
    hooks:{
      reset(){},//调用重置时候的方法，可不填
      getValue(){}，//调用查询时候调用的方法，可不填
    }
  }
*/
function useForm(list) {
  let reactiveList = reactive(
    list.map(minixFormItem).map((item, index) => {
      EventList.forEach((key) => {
        if (typeof item[key] != 'undefined') {
          Object.entries(item[key]).forEach(([fnKey, fn]) => {
            item[key][fnKey] = function () {
              return fn(...arguments, reactiveList[index], reactiveList)
            }
          })
        }
      })
      if (typeof item['value'] == 'undefined') {
        item['value'] = null
      }
      if (typeof item['key'] == 'undefined') {
        console.error('每一个form都需要一个Key')
      }
      return item
    })
  )
  return reactiveList
}
function minixFormItem(item) {
  let props = {},
    events = {},
    hooks = {}
  switch (item.type) {
    case FORMSELECT:
      item.options = item.options || []
      props = {
        allowClear: true
      }
      events = {
        dropdownVisibleChange(open, item) {
          const options = isRef(item.options)
          if (open && options.length == 0) {
            getOptionsByKey(item.key).then((res) => {
              item.options = res
            })
          }
        }
      }
      hooks = {
        reset(item) {
          item.value = item.props.mode === 'multiple' ? [] : null
        },
        getValue(item) {
          if (vaildNull(item.value)) {
            return null
          } else {
            return {
              key: item.key,
              value: item.value
            }
          }
        }
      }
      break
    case FORMINPUTNUMBER:
      hooks = {
        reset(item) {
          item.value = null
        },
        getValue(item) {
          if (vaildNull(item.value)) {
            return null
          } else {
            return {
              key: item.key,
              value: item.value
            }
          }
        }
      }
      break
    case FORMINPUT:
      hooks = {
        reset(item) {
          item.value = null
        },
        getValue(item) {
          if (vaildNull(item.value)) {
            return null
          } else {
            return {
              key: item.key,
              value: item.value.trim()
            }
          }
        }
      }
      break
    case FORMDATEPICKER:
      events = {}
      if (Array.isArray(item.key)) {
        props = {}
      }
      hooks = {
        reset(item) {
          item.value = null
        },
        getValue(item) {
          if (vaildNull(item.value)) {
            return null
          } else {
            if (Array.isArray(item.key)) {
              let [value1, value2] = item.value
              let [key1, key2] = item.key
              console.log(item.value)
              return [
                {
                  key: key1,
                  value: value1
                },
                {
                  key: key2,
                  value: value2
                }
              ]
            } else {
              return {
                key: item.key,
                value: item.value
              }
            }
          }
        }
      }
      break
    case FORMSLECTDEPT: 
      hooks = {
        reset(item) {
          item.value = item.props.multiple ? [] : undefined
        },
        getValue(item) {
          if (vaildNull(item.value)) {
            return item.props.multiple ? [] : undefined
          } else {
            return {
              key: item.key,
              value: item.value
            }
          }
        }
      }
      break
    case FORMSLECTUSER: 
      hooks = {
        reset(item) {
          // 清空输入框已有的文字
          if (item?.ref && item?.ref?.clearInputText) {
            item?.ref?.clearInputText()
          }
          // 清空输入内容
          item.value = item.props.multiple ? [] : undefined
        },
        getValue(item) {
          // 清空输入框已有的文字
          if (item?.ref && item?.ref?.clearInputText) {
            item?.ref?.clearInputText()
          }
          // 返回结果
          if (vaildNull(item.value)) {
            return item.props.multiple ? [] : undefined
          } else {
            return {
              key: item.key,
              value: item.value
            }
          }
        }
      }
      break
  }
  item.props = Object.assign({}, props, item.props || {})
  item.events = Object.assign({}, events, item.events || {})
  item.hooks = Object.assign({}, hooks, item.hooks || {})
  return item
}
useForm.constants = {
  FORMINPUT,
  FORMINPUTNUMBER,
  FORMSELECT,
  FORMDATEPICKER,
  FORMTIMEPICKER
}
export default useForm
